import PropTypes from 'prop-types';
import React from 'react';
import {intlShape, FormattedMessage} from 'react-intl';
import {EnvironmentShape} from '../../../utils/react/Shapes';
import FontAwesome from 'react-fontawesome';
import PublicMessages from './PublishMessages';
import moment from 'moment';

class PublishEnvironment extends React.Component {

  static propTypes = {
    env: EnvironmentShape.isRequired,
    scheduleButtonClickHandler: PropTypes.func.isRequired
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
    intl: intlShape
  };

  constructor(props) {
    super(props);
  }

  clickPublish = (event) => {
    console.log('clickPublish', event.target.checked);
    this.props.scheduleButtonClickHandler(this.props.env.environmentKey, event.target.checked);
  };

  render() {
    const {environmentKey, guidesChanged, branchesChanged, productsChanged} = this.props.env;

    const guides = (guidesChanged.length > 0) ? guidesChanged.map(g =>
        <div key={g}>{g}</div>
      ) : <div>No recent changes.</div>;

    const branches = (branchesChanged.length > 0) ? branchesChanged.map(b =>
        <div key={b}>{b}</div>
      ) : <div>No recent changes.</div>;

    const products = (productsChanged.length > 0) ? productsChanged.map(p =>
        <div key={p}>{p}</div>
      ) : <div>No recent changes.</div>;

    const {lastPublished} = this.props.env;

    const timestamp = (lastPublished) ? <div className='flex-container timestamp flex-justify-end'>
        <span>Last published: {moment(lastPublished).format('dddd, MMMM Do YYYY, h:mm a')}</span>
      </div> : <div className='flex-container timestamp flex-justify-end'>
        <span>Has not been published.</span>
      </div>;

    const intl = this.context.intl;
    const alreadyScheduledMsg = intl.formatMessage(PublicMessages.alreadyScheduled);
    const scheduleMsg = intl.formatMessage(PublicMessages.schedule);

    const msgKey = `${environmentKey}-environment`;
    const envMessage = PublicMessages[msgKey];

    return <div className='flex-container flex-vertical flex-element'>
      <div className='flex-container flex-justify-between'>
        <h4 className='env-name'>
          <FormattedMessage {...envMessage}/>:
        </h4>
        <h4 className='publish-button'>
          <button className='btn btn-primary' onClick={this.clickPublish}>
            <span className='publish-icon'>
              <FontAwesome name='cloud-upload'/>
            </span>
            <span>
              {scheduleMsg}
            </span>
          </button>
        </h4>
      </div>
      {timestamp}
      <div className='flex-container'>
        <div className='publish-changes-box flex-element'>
          <h5 className='publish-changes-title'>Dialogues Changed:</h5>
          {guides}
        </div>
        <div className='publish-changes-box flex-element'>
          <h5 className='publish-changes-title'>Products Changed:</h5>
          {products}
        </div>
        <div className='publish-changes-box flex-element'>
          <h5 className='publish-changes-title'>Branches Changed:</h5>
          {branches}
        </div>
      </div>
    </div>;
  }
}

export default PublishEnvironment;



// WEBPACK FOOTER //
// ./src/apps/Publish/components/PublishEnvironment.js